.card {
  background-color: var(--color-grey-200);
  display: flex;
  flex-direction: column;
}

.card--regular,
.card--large {
  gap: 1.5rem;
  padding: 1.5rem;
}

.card--small {
  gap: 1rem;
  padding: 1rem;
}

/* adjusted styling on screens larger than 448px/28rem */
@media (min-width: 28rem) and (min-height: 28rem) {
  .card--large {
    gap: 3rem;
    padding: 3rem;
  }
}

.card-header {
  align-items: center;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
}

.card--high-contrast {
  background-color: var(--color-uva-white);
}

.card--align-center {
  align-items: center;
}
